import * as ActionsTypes from './constants';

const initialState = {
  data: null,
  isError: false,
  isLoading: false,
};

export default function clanReducer(state = initialState, action) {
  switch (action.type) {
    case ActionsTypes.FETCHING_CLAN_INFO_REQUEST:
      return {
        ...state,
        isError: false,
        isLoading: true,
      };
    case ActionsTypes.FETCHING_CLAN_INFO_FAILURE:
      return {
        ...state,
        isError: true,
        isLoading: false,
      };
    case ActionsTypes.FETCHING_CLAN_INFO_SUCCESS:
      return {
        ...state,
        isError: false,
        isLoading: false,
        data: action.payload,
      };
    default:
      return state;
  }
}
